/**
 * 작성자 : 김광민
 * 날짜 : 2024.02.26
 * 기능 : 단축키가 존재하는 버튼
 */

import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const Root = styled.div<{ $disabled?: boolean }>`
  user-select: none;
  cursor: pointer;
  background-color: var(--tonal-light);
  border: 1px solid var(--outline);
  border-radius: 0.25rem;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  justify-content: center;
  gap: 0.5rem;
  height: 2.5rem;
  padding: 0.75rem;
  padding-right: 0.25rem;
  .buttonText {
    font-size: 0.875rem;
    color: var(--text-secondary);
  }
  .shortcut {
    background-color: var(--tonal-light);
    color: var(--text-disabled);
    border-radius: 0.25rem;
    font-size: 0.75rem;
    letter-spacing: 0;
    width: 1.75rem;
    height: 1.75rem;
    letter-spacing: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid var(--outline-em);
    font-weight: 600;
  }
  &:hover {
    background-color: var(--tonal);
    .shortcut {
      color: var(--text-tertiary);
    }
  }
  &:active {
    background-color: var(--tonal-deep);
  }
  ${({ $disabled }) =>
    $disabled &&
    `
      cursor: not-allowed;
      opacity: 0.5;
      pointer-events: none;
    `}
  &.useIcon {
    padding-left: 0.5rem;
    .buttonText {
      display: flex;
      align-items: center;
      /* color: var(--text-secondary); */
      color: var(--text-primary);
      font-weight: 600;
      .material-symbols-rounded {
        font-size: 1.375rem;
        font-size: 1.25rem;
        margin-right: 0.25rem;
        /* margin-right: 0.125rem; */
      }

      &.padding-right-0-5rem {
        padding-right: 0.5rem;
      }
    }
    .shortcut {
      /* color: var(--text-tertiary); */
      color: var(--text-secondary);
    }
    &:hover {
      background-color: var(--tonal-deep);
    }
  }
`;

type Props = {
  onClick: () => void;
  buttonText: string;
  shortcut?: string;
  icon?: string;
  disabled?: boolean;
};

const ShortcutButton = ({ onClick, buttonText, shortcut, icon, disabled = false }: Props) => {
  const { t } = useTranslation();
  return (
    <Root onClick={disabled ? undefined : onClick} role='button' aria-disabled={disabled} className='useIcon' $disabled={disabled}>
      <span className={`buttonText ${shortcut ? '' : 'padding-right-0-5rem'}`}>
        {icon && <span className='material-symbols-rounded'>{icon}</span>}
        {t(buttonText)}
      </span>
      {shortcut && <span className='shortcut'>{shortcut}</span>}
    </Root>
  );
};

export default ShortcutButton;
